import { tenantSettings } from "utils/authentication/tenantSettings";
import { BOOKING_JOURNEY } from "utils/constants";

export const GetApolloLinkWithToken = (authenticationResult, request, headers: any) => {
  // Handle null authentication result - this can happen during auth flow
  // Return headers without auth to prevent UNAUTHENTICATED errors during login
  if (!authenticationResult) {
    console.debug("No authentication result available for this request - skipping auth headers");
    return {
      headers: {
        ...headers,
      },
      uri: request?.operationName?.toLowerCase().includes(BOOKING_JOURNEY.toLowerCase())
        ? process.env.REACT_APP_IBF_URL
        : tenantSettings.customConfig.api.baseUrl,
    };
  }

  const { accessToken, idToken } = authenticationResult;
  let authHeaders = tenantSettings.customConfig.getRequestHeaders?.(idToken, accessToken) || {};

  let apiURL = tenantSettings.customConfig.api.baseUrl;
  if (request?.operationName?.toLowerCase().includes(BOOKING_JOURNEY.toLowerCase())) {
    apiURL = process.env.REACT_APP_IBF_URL;
    authHeaders["klp-version"] = "1.0";
  }

  return {
    headers: {
      ...headers,
      ...authHeaders,
    },
    uri: apiURL,
  };
};
